// Persistent Parent Dashboard navigation: Home | Children | Progress |
// Family | Settings. Sticky under the header, horizontally scrollable on
// mobile, active section clearly marked.
import { NavLink } from "react-router-dom";
import { Home, LineChart, Settings, Users, UsersRound } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", key: "home", label: "Home", icon: Home, end: true },
  { to: "/dashboard/children", key: "children", label: "Children", icon: Users },
  { to: "/dashboard/progress", key: "progress", label: "Progress", icon: LineChart },
  { to: "/dashboard/family", key: "family", label: "Family", icon: UsersRound },
  { to: "/dashboard/settings", key: "settings", label: "Settings", icon: Settings },
];

export const DashboardNav = () => (
  <nav
    className="sticky top-0 z-20 bg-card/80 backdrop-blur border-b border-border"
    aria-label="Dashboard sections"
    data-testid="dashboard-nav"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto">
      {ITEMS.map(({ to, key, label, icon: Icon, end }) => (
        <NavLink
          key={key}
          to={to}
          end={end}
          className={({ isActive }) =>
            `shrink-0 inline-flex items-center gap-2 px-4 py-3 text-sm font-extrabold border-b-[3px] transition-colors ${
              isActive
                ? "border-violet-600 text-violet-700"
                : "border-transparent text-muted-foreground hover:text-foreground"
            }`
          }
          data-testid={`dash-nav-${key}`}
        >
          <Icon className="h-4 w-4" aria-hidden="true" />
          {label}
        </NavLink>
      ))}
    </div>
  </nav>
);
